import { CrudServiceBase } from '@utils/service';
import { AssesmentQuestion } from './assesment-question.class';

export class AssesmentQuestionService extends CrudServiceBase<AssesmentQuestion> {
	constructor(assesmentId: string) {
		super(AssesmentQuestion, `assesment/${assesmentId}/assesment-question`);
	}
}
